export enum ChangeRequestStatusTypes {
    UNSUBMITTED = "UNSUBMITTED",
    SUBMITTED = "SUBMITTED",
    APPROVED = "APPROVED",
    CANCELED = "CANCELED",
    UNDER_REVIEW = "UNDER_REVIEW",
    REJECTED = "REJECTED",
    DEPLOYED = "DEPLOYED",
    DEPLOYMENT_SCHEDULED = 'DEPLOYMENT_SCHEDULED',
}